document.addEventListener('DOMContentLoaded', function () {
    // Domain and API Token
    const storeDomain = 'usrigging.com';
    const storefrontToken = 'a1f7d6fb63fd9d4c43806798f0f8bf24';

    // ===== Fetch Products by SKU =====
    async function fetchProductsBySKU(skuInput) {
        const query = `
        {
            products(first: 20, query: "${skuInput}") {
                edges {
                    node {
                        id
                        title
                        handle
                        featuredImage { url }
                        variants(first: 10) {
                            edges {
                                node {
                                    sku
                                    price { amount currencyCode }
                                }
                            }
                        }
                    }
                }
            }
        }`;

        const response = await fetch(`https://${storeDomain}/api/2025-01/graphql.json`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': storefrontToken,
            },
            body: JSON.stringify({ query }),
        });

        const data = await response.json();
        const products = data.data?.products?.edges || [];

        // Filter products based on SKU
        return products.filter(product =>
            product.node.variants.edges.some(v =>
                v.node.sku && v.node.sku.toLowerCase().includes(skuInput.toLowerCase())
            )
        );
    }

    // ===== Fetch Top-Selling Products =====
    async function fetchTopSellingProducts(limit = 3) {
        const query = `
        {
            products(first: ${limit}, sortKey: BEST_SELLING) {
                edges {
                    node {
                        id
                        title
                        handle
                        featuredImage { url }
                        variants(first: 1) {
                            edges {
                                node {
                                    price { amount currencyCode }
                                }
                            }
                        }
                    }
                }
            }
        }`;

        const response = await fetch(`https://${storeDomain}/api/2025-01/graphql.json`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': storefrontToken,
            },
            body: JSON.stringify({ query }),
        });

        const data = await response.json();
        return data.data?.products?.edges || [];
    }

    // ===== Main Search Function =====
    async function runSearch(searchInput) {
        const queryText = searchInput.value.trim();
        if (queryText.length < 2) return;

        const resultsList = document.querySelector('#predictive-search-results-list');
        if (!resultsList) return;

        // Remove old SKU, loading, or message elements
        resultsList.querySelectorAll('[id^="predictive-search-option-sku-"], .sku-loading-message, .no-results-message, .popular-products-header')
            .forEach(el => el.remove());

        // Reference to search keywords li
        const keywordItem = resultsList.querySelector('#predictive-search-option-search-keywords');

        // Add temporary loading message before keywords
        const loadingHTML = `
            <li class="sku-loading-message predictive-search__list-item text-center py-2" aria-disabled="true">
                <em>Looking for additional recommendations...</em>
            </li>
        `;
        if (keywordItem) {
            keywordItem.insertAdjacentHTML('beforebegin', loadingHTML);
        } else {
            resultsList.insertAdjacentHTML('beforeend', loadingHTML);
        }

        // Fetch by SKU
        const products = await fetchProductsBySKU(queryText);

        // Remove loading message
        resultsList.querySelectorAll('.sku-loading-message').forEach(el => el.remove());

        // If no matches found
        if (products.length === 0) {
            const otherLis = [...resultsList.querySelectorAll('li')]
                .filter(li => li.id !== 'predictive-search-option-search-keywords');

            if (otherLis.length === 0) {
                // Add "No results" message before keywords
                const noResultsHTML = `
                    <li class="no-results-message predictive-search__list-item text-center py-2 text-muted">
                        <em>No matching products found.</em>
                    </li>
                `;
                if (keywordItem) {
                    keywordItem.insertAdjacentHTML('beforebegin', noResultsHTML);
                } else {
                    resultsList.insertAdjacentHTML('beforeend', noResultsHTML);
                }

                // Fetch top 3 best-selling products
                const topSellingProducts = await fetchTopSellingProducts(3);
                if (topSellingProducts.length > 0) {
                    const topTitleHTML = `
                        <li class="popular-products-header predictive-search__list-item text-center fw-bold py-2">
                            <em>Popular products</em>
                        </li>
                    `;

                    // Insert before keywords (so the section stays above)
                    if (keywordItem) {
                        keywordItem.insertAdjacentHTML('beforebegin', topTitleHTML);
                    } else {
                        resultsList.insertAdjacentHTML('beforeend', topTitleHTML);
                    }

                    // Insert top-selling items before keywords, in reverse order
                    [...topSellingProducts].reverse().forEach((product, i) => {
                        const handle = product.node.handle;
                        const firstVariant = product.node.variants.edges[0]?.node;
                        const price = firstVariant?.price?.amount
                            ? `$${parseFloat(firstVariant.price.amount).toFixed(2)}`
                            : '';
                        const imageUrl = product.node.featuredImage?.url || '';

                        const itemHTML = `
                            <li id="predictive-search-option-top-${i + 1}"
                                class="predictive-search__list-item"
                                role="option"
                                aria-selected="false"
                                data-product-handle="${handle}">
                                <a href="/products/${handle}"
                                    class="predictive-search__item predictive-search__item--link link link--text px-3 pb-2 pt-1"
                                    tabindex="-1">
                                    ${imageUrl ? `<img src="${imageUrl}&width=50" alt="${product.node.title}" width="50" height="50" loading="lazy" class="img-fluid me-2 pe-1">` : ''}
                                    <div class="predictive-search__item-content">
                                        <div class="predictive-search__item-heading effect-line">
                                            <span>${product.node.title}</span>
                                        </div>
                                        <div class="predictive-search__price d-flex align-items-center">
                                            <div class="product-price">${price}</div>
                                        </div>
                                    </div>
                                </a>
                            </li>
                        `;

                        if (keywordItem) {
                            keywordItem.insertAdjacentHTML('beforebegin', itemHTML);
                        } else {
                            resultsList.insertAdjacentHTML('beforeend', itemHTML);
                        }
                    });
                }
            }
            return;
        }

        // Otherwise, show SKU matches
        products.forEach((product, i) => {
            const handle = product.node.handle;
            if (resultsList.querySelector(`[data-product-handle="${handle}"]`)) return;

            const firstVariant = product.node.variants.edges[0]?.node;
            const price = firstVariant?.price?.amount
                ? `$${parseFloat(firstVariant.price.amount).toFixed(2)}`
                : '';
            const imageUrl = product.node.featuredImage?.url || '';

            const itemHTML = `
                <li id="predictive-search-option-sku-${i + 1}"
                    class="predictive-search__list-item"
                    role="option"
                    aria-selected="false"
                    data-product-handle="${handle}">
                    <a href="/products/${handle}"
                        class="predictive-search__item predictive-search__item--link link link--text px-3 pb-2 pt-1"
                        tabindex="-1">
                        ${imageUrl ? `<img src="${imageUrl}&width=50" alt="${product.node.title}" width="50" height="50" loading="lazy" class="img-fluid me-2 pe-1">` : ''}
                        <div class="predictive-search__item-content">
                            <div class="predictive-search__item-heading effect-line">
                                <span>${product.node.title}</span>
                            </div>
                            <div class="predictive-search__price d-flex align-items-center">
                                <div class="product-price">${price}</div>
                            </div>
                        </div>
                    </a>
                </li>
            `;

            if (keywordItem) {
                keywordItem.insertAdjacentHTML('beforebegin', itemHTML);
            } else {
                resultsList.insertAdjacentHTML('beforeend', itemHTML);
            }
        });
    }


    // ===== Initialize Observer =====
    function initPredictiveSearch() {
        const searchInput = document.querySelector('.search__input');
        const predictiveContainer = document.querySelector('predictive-search');
        if (!searchInput || !predictiveContainer) return;

        let debounceTimer;

        // Debounced input search
        searchInput.addEventListener('input', () => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                runSearch(searchInput);
            }, 800);
        });

        // Observe predictive-search for new results list
        const observer = new MutationObserver(mutations => {
            for (const mutation of mutations) {
                if ([...mutation.addedNodes].some(node =>
                    node.id === 'predictive-search-results-list' ||
                    (node.querySelector && node.querySelector('#predictive-search-results-list'))
                )) {
                    setTimeout(() => runSearch(searchInput), 150);
                    break;
                }
            }
        });

        observer.observe(predictiveContainer, { childList: true, subtree: true });
    }

    initPredictiveSearch();
});
